import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import EducationHeroSection from './components/EducationHeroSection';
import BooksSection from './components/BooksSection';
import NewsletterSection from './components/NewsletterSection';
import LibrariesSection from './components/LibrariesSection';
import WorkshopsSection from './components/WorkshopsSection';
import EducationCTASection from './components/EducationCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/education#webpage`,
      url: `${siteUrl}/education`,
      name: 'Oxygen Health Education | Free Books, Workshops & Resources – Diatomic Life Foundation',
      description:
        'Free books, workshops, and library resources on oxygen health and deficiency prevention, provided by Diatomic Life Foundation.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Education', item: `${siteUrl}/education` },
        ],
      },
    },
    {
      '@type': 'EducationalOrganization',
      '@id': `${siteUrl}/education#edorg`,
      name: 'Diatomic Life Foundation – Education',
      url: `${siteUrl}/education`,
      description: 'Free books, workshops, and library resources on oxygen health and deficiency prevention.',
      parentOrganization: { '@id': `${siteUrl}/#organization` },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Free Oxygen Health Resources',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Book',
              name: 'Free Oxygen Health Books',
              description: 'Comprehensive guides on oxygen deficiency, prevention, and supplementation.',
            },
            price: '0',
            priceCurrency: 'INR',
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Course',
              name: 'Community Oxygen Health Workshops',
              description: 'In-person and online workshops on oxygen health for communities across India.',
              provider: { '@id': `${siteUrl}/#organization` },
            },
            price: '0',
            priceCurrency: 'INR',
          },
        ],
      },
    },
  ],
};

export default function Education() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Oxygen Health Education | Free Books, Workshops & Resources – Diatomic Life Foundation"
        description="Access free books, community workshops, and library resources on oxygen deficiency and health. Diatomic Life Foundation empowers communities through education."
        keywords="oxygen health education, oxygen deficiency books, free health workshops, Diatomic Life Foundation education"
        canonical={`${siteUrl}/education`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <EducationHeroSection />
        <BooksSection />
        <NewsletterSection />
        <LibrariesSection />
        <WorkshopsSection />
        <EducationCTASection />
      </main>
      <Footer />
    </div>
  );
}
